<template>
  <Modal
    :title="title"
    :saving="saving"
    :disabled="hasPayments"
    saving-text="Processing..."
    submit-btn-text="Void Invoice"
    submit-btn-class="btn btn-sm btn-danger ml-auto"
    @submit="handleSubmit"
    @hide-modal="$emit('hide-modal')"
  >
    <div class="form-group mb-0">
      <WarningMessage>{{ warningMessage }}</WarningMessage>
      <TextArea
        v-if="!hasPayments"
        v-model="reason"
        class="full-width"
        name="Reason"
        label="Please provide a reason for voiding this invoice"
        :validation-errors="v$.$errors"
      >
      </TextArea>
    </div>
  </Modal>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    Modal,
    TextArea,
    WarningMessage
  },
  props: {
    invoice: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      reason: "",
      saving: false
    };
  },
  computed: {
    title() {
      if (!this.invoice) return "Void Invoice";
      return `Void Invoice #${this.invoice.invoice_id}`;
    },
    hasPayments() {
      if (!this.invoice) {
        return false;
      }

      return this.invoice.financials.refundable_amount_cents > 0;
    },
    warningMessage() {
      if (this.hasPayments) {
        return "Invoice cannot be voided until all payments have been refunded.";
      }

      return "Voiding this invoice will zero out all line items and prevent any additional changes.";
    }
  },
  validations() {
    return {
      reason: { required, $autoDirty: true }
    };
  },
  methods: {
    ...mapActions(["voidInvoice"]),
    async handleSubmit() {
      const isValid = await this.v$.$validate();
      if (!isValid) {
        return;
      }

      this.saving = true;
      try {
        await this.voidInvoice({
          link: this.invoice.links.void,
          reason: this.reason
        });
        window.notify.success(
          `Invoice #${this.invoice.invoice_id} has been voided.`
        );
        this.$emit("hide-modal");
        EventBus.$emit("invoice-voided");
        EventBus.$emit("refresh-job");
      } catch (error) {
        Sentry.captureException(error);
        console.error(error);
      }
      this.saving = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
